'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const universal_color = require('../../style/universal.color.js');
const aspectRatioPercentage = require('../../utils/aspectRatioPercentage.js');
const image = require('../Image/image.js');
const headshot_types = require('./headshot.types.js');
const headshot_style = require('./headshot.style.js');

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AMP = '&';
var ONE_BY_ONE = '1:1';
var HeadshotTypeAspectRatios = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, headshot_types.HeadshotTypes.DEFAULT, ONE_BY_ONE), headshot_types.HeadshotTypes.SILO, ONE_BY_ONE), headshot_types.HeadshotTypes.SPOTS, ONE_BY_ONE), headshot_types.HeadshotTypes.MILB, '2:3'), headshot_types.HeadshotTypes.SIXTY_SEVEN, '2:3'), headshot_types.HeadshotTypes.EIGHTY_THREE, '24:29');
var sizeRange = [30, 60, 90, 120, 150, 180, 240];
var HeadshotFallback = 'https://prod-gameday.mlbstatic.com/responsive-gameday-assets/1.3.0/images/players/default-batter.svg';
var generateUrl = function generateUrl(scaling, playerId, zoomLevel, width, type, asCircle) {
  var headshotWidth = width * scaling;
  var query = [];
  if (zoomLevel > 1) {
    query.push("zoom=".concat(zoomLevel));
  }
  if (asCircle) {
    query.push('circle=true');
  }
  return "https://midfield.mlbstatic.com/v1/people/".concat(playerId, "/").concat(type, "/").concat(headshotWidth).concat(query.length ? '?' + query.join(AMP) : '');
};

// want to keep to a range of acceepted sizes to keep asset costs down
var generateRoundedSize = function generateRoundedSize(width) {
  var rangeLength = sizeRange.length;
  var headshotWidth = sizeRange[rangeLength - 1];
  var widthNum = typeof width === 'string' ? width.replace('px', '') : width;
  for (var i = 0; i < rangeLength; i++) {
    if (sizeRange[i] >= widthNum) {
      headshotWidth = sizeRange[i];
      break;
    }
  }
  return headshotWidth;
};
var constructHeadshotURLSrcset = function constructHeadshotURLSrcset(playerId, zoomLevel, width, type) {
  var asCircle = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  // set img to appropriate width
  // TODO what if percentage?
  var headshotWidth = generateRoundedSize(width);
  return {
    '1x': generateUrl(1, playerId, zoomLevel, headshotWidth, type, asCircle),
    '2x': generateUrl(2, playerId, zoomLevel, headshotWidth, type, asCircle),
    '3x': generateUrl(3, playerId, zoomLevel, headshotWidth, type, asCircle)
  };
};
var Headshot = function Headshot(props) {
  var _props$src = props.src,
    src = _props$src === void 0 ? '' : _props$src,
    srcset = props.srcset,
    playerId = props.playerId,
    _props$rounded = props.rounded,
    rounded = _props$rounded === void 0 ? true : _props$rounded,
    _props$type = props.type,
    type = _props$type === void 0 ? headshot_types.HeadshotTypes.DEFAULT : _props$type,
    _props$errorImageSrc = props.errorImageSrc,
    errorImageSrc = _props$errorImageSrc === void 0 ? HeadshotFallback : _props$errorImageSrc,
    isLoading = props.isLoading,
    _props$width = props.width,
    width = _props$width === void 0 ? '60px' : _props$width,
    _props$zoomScale = props.zoomScale,
    zoomScale = _props$zoomScale === void 0 ? 1.2 : _props$zoomScale;
  var _props$ratio = props.ratio,
    ratio = _props$ratio === void 0 ? HeadshotTypeAspectRatios[type] || HeadshotTypeAspectRatios[headshot_types.HeadshotTypes.DEFAULT] : _props$ratio;
  var isSilo = type === headshot_types.HeadshotTypes.SILO;
  var isSpots = type === headshot_types.HeadshotTypes.SPOTS;
  var isOneByOne = ratio == ONE_BY_ONE;
  var closeUp = props.closeUp,
    _props$backgroundColo = props.backgroundColor,
    backgroundColor = _props$backgroundColo === void 0 ? isSilo ? universal_color.mlbGrey1 : undefined : _props$backgroundColo;
  var borderRadius;
  if (!isOneByOne) {
    closeUp = closeUp === true;
    borderRadius = '8px';
  } else {
    closeUp = closeUp !== false;
    borderRadius = '50%';
  }
  if (isLoading) {
    var skeletonRatio = aspectRatioPercentage(ratio);
    return /*#__PURE__*/React__default.createElement(headshot_style.HeadshotSkeleton, {
      width: width,
      ratio: skeletonRatio,
      isCircle: rounded && isOneByOne,
      borderRadius: borderRadius
    });
  }
  var zoomLevel = closeUp ? zoomScale : 1;
  var providedSrcset = srcset;

  // If user has passed a playerId, give that precedence and build the srcset.
  if (playerId != undefined) {
    providedSrcset = React.useMemo(function () {
      //  If the user is asking for 1:1, and an image type isn't an implicit 1:1 (silo, spots)
      var asCircle = !(isSpots || isSilo) && isOneByOne;
      return constructHeadshotURLSrcset(playerId, zoomLevel, width, type, asCircle);
    }, [playerId, zoomLevel, width, type, isOneByOne, props.ratio]);
  }
  var providedSrc = playerId != undefined && providedSrcset && providedSrcset['1x'] || src;
  return /*#__PURE__*/React__default.createElement(image.default, _extends({}, props, {
    key: playerId,
    src: providedSrc,
    srcset: providedSrcset,
    ratio: ratio,
    rounded: isOneByOne && rounded,
    borderRadius: rounded ? borderRadius : undefined,
    errorImageSrc: errorImageSrc,
    backgroundColor: backgroundColor,
    sizes: typeof width === 'number' ? "".concat(width, "px") : width
  }));
};

exports.HeadshotTypes = headshot_types.HeadshotTypes;
exports.HeadshotFallback = HeadshotFallback;
exports.constructHeadshotURLSrcset = constructHeadshotURLSrcset;
exports.default = Headshot;
